import moment from "moment";
import { useEffect, useState } from "react";
import Breadcrumbs from "../../globals/core/Breadcrumbs/Breadcrumb";
import DatatableTables from "../../globals/core/Tables/DatatableTables";
import { EventsService } from "../../globals/services/events.service";
import { useHistory, Link } from "react-router-dom";
import { environment } from "../../environment";
import { Input, Label } from "reactstrap";

export const Events = () => {
  const history = useHistory();
  const [items, setItems] = useState([]);
  const [loaderAction, setLoaderAction] = useState(false);
  const [arg, setArg] = useState(null);
  const [param, setParam] = useState(null);
  const [nonFilterItems, setNonFilterItems] = useState([]);
  const lastDaysOptions = [30, 90, 180];
  const nextDaysOptions = [7, 30, 90, 180];
  const filterOptions = [
    { param: "language", value: "English", label: "English" },
    { param: "language", value: "Hebrew", label: "עברית" },
    { param: "language", value: "Arabic", label: "عربي" },
    { param: "tagTitle", value: "clp", label: "CLP" },
    { param: "tagTitle", value: "rabbinic", label: "RTS" },
    { param: "tagTitle", value: "חזון", label: "חזון" },
    { param: "tagTitle", value: "board", label: "BOARD" },
    { param: "tagTitle", value: "teen fellowship", label: "Teen Fellowship" },
    { param: "allseminars", value: 0, label: "All Seminars" },
    { param: "all", value: 0, label: "Reset" },
  ];

  useEffect(() => {
    getItems();
  }, []);

  useEffect(() => {
    if (arg || param) {
      getItemsFiltered();
    }
  }, [arg, param]);

  const getItems = async () => {
    setLoaderAction(true);
    try {
      const _items = await EventsService().getEventAdminItems();
      const parsedItems = parseItems(_items || []);
      setItems(parsedItems);
      setNonFilterItems(parseItems);
    } catch (err) {
      console.error(err);
    }
    setLoaderAction(false);
  };

  const getItemsFiltered = async () => {
    setLoaderAction(true);
    try {
      const _items = await EventsService().filterEventItems(arg, param);
      const parsedItems = parseItems(_items || []);
      setItems(parsedItems);
    } catch (err) {
      console.error(err);
    }
    setLoaderAction(false);
  };

  const resetSeminars = () => {
    setArg(null);
    setParam(null);
    setItems(nonFilterItems);
  };

  const parseItems = (items = []) => {
    return items
      .sort((a, b) => new Date(b.dtStartDate) - new Date(a.dtStartDate))
      .map((i) => {
        return {
          entity: i,
          id: i._id,
          title: i.eventTitle,
          language: i.language,
          sessions: i.sessions ? i.sessions.length : 0,
          tasks: i.seminarTasks ? i.seminarTasks.length : 0,
          start: i.dtStartDate,
          created: i.dateCreated,
          action: i,
          sfdcaction: i,
        };
      });
  };

  const filterByEventsByParam = (e, arg, param) => {
    if (arg === "all" || (arg === "title" && param.length === 0)) {
      resetSeminars();
    } else {
      setArg(arg);
      setParam(param);
    }
  };

  const openCurrentEvent = (item) => {
    history.push({
      pathname: "/CurrentEventEditForm/" + item._id,
    });
  };

  const columns = [
    {
      dataField: "title",
      text: "Title",
      sort: true,
    },
    {
      dataField: "language",
      text: "Language",
      sort: true,
    },
    {
      dataField: "sessions",
      text: "Sessions",
      sort: true,
    },
    {
      dataField: "tasks",
      text: "Tasks",
      sort: true,
    },
    {
      dataField: "start",
      text: "Start Date",
      formatter: (date) => {
        return moment(date).format("D MMM YYYY");
      },
      sort: true,
    },
    {
      dataField: "created",
      text: "Created Date",
      formatter: (date) => {
        return moment(date).format("D MMM YYYY");
      },
      sort: true,
    },
    {
      dataField: "action",
      text: "",
      formatter: (item) => {
        return (
          <button className="btn btn-success" onClick={() => openCurrentEvent(item)}>
            Manage Event
          </button>
        );
      },
      sort: false,
    },
    {
      dataField: "sfdcaction",
      text: "",
      formatter: (item) => {
        return (
          <Link className="linkToSalesforce" to={{ pathname: environment.sfdcUrl + item.sfSeminarId }} target="_blank">
            Go To SFDC
          </Link>
        );
      },
      sort: false,
    },
  ];

  return (
    <div className="content">
      <div className="page-content">
        <div className="container-fluid">
          <div className="mb-3">
            <Breadcrumbs title="MAIN" breadcrumbItem="SEMINARS" />
          </div>

          <div className="row mb-2">
            <div className="col-9 d-flex">
              <div className="form-group col-md-3 mr-2">
                <h5 className="mt-4">
                  <Label htmlFor="_name">Seminar Title</Label>
                </h5>
                <Input id="searchName" name="searchName" placeholder="Search by title..." type="text" onChange={(e) => filterByEventsByParam(e, "title", e.target.value)} />
              </div>

              <div className="form-group col-md-4">
                <h5 className="mt-4 ml-2">
                  <Label htmlFor="_name">Created Date</Label>
                </h5>
                <div className="d-flex">
                  {lastDaysOptions.map((days) => (
                    <div key={days} className="filterLastDays ml-2" onClick={(e) => filterByEventsByParam(e, "last", days)}>
                      Last {days} days
                    </div>
                  ))}
                </div>
              </div>

              <div className="form-group col-md-5 mr-2">
                <h5 className="mt-4">
                  <Label htmlFor="_name">Start Date</Label>
                </h5>
                <div className="d-flex">
                  {nextDaysOptions.map((days) => (
                    <div key={days} className="filterNextDays ml-2" onClick={(e) => filterByEventsByParam(e, "next", days)}>
                      Last {days} days
                    </div>
                  ))}
                  <div className="filterNextDays ml-2" onClick={(e) => filterByEventsByParam(e, "currentYear", 180)}>
                    This Year
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="row mb-2">
            <div className="col-9 d-flex">
              <div className="form-group col-md-12 mr-2">
                <div className="d-flex">
                  {filterOptions.map(({ param, value, label }) => (
                    <div
                      key={label}
                      className={param === "allseminars" ? "filterNextDays" : param === "all" ? "resetfilter" : "filterByParam"}
                      onClick={(e) => filterByEventsByParam(e, param, value)}
                    >
                      {label}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>

          {loaderAction && (
            <div className="loaderContainer d-flex flex-column">
              <div className="loader"></div>
              <div className="loaderText">Loading Seminars</div>
            </div>
          )}

          {!loaderAction && (
            <div>
              <div>
                {items.length} Seminars found {items.length === 0 ? "for:" : null}
              </div>

              {(arg === "last" || arg === null) && arg !== "title" && (
                <div>
                  {param === null ? <span>Created in the last 30 days: &nbsp; </span> : <span>Created in the last {param} days &nbsp;</span>}
                  {param === null ? moment().subtract(30, "days").format("MM/DD/YYYY") : moment().subtract(parseInt(param), "days").format("MM/DD/YYYY")}-{" "}
                  {moment().format("MM/DD/YYYY")}
                </div>
              )}

              {(arg === "next" || arg === null) && arg !== "title" && (
                <div>
                  {param === null ? <span>Start in the next 60 days: &nbsp;</span> : <span>Start in the next {param} days: &nbsp;</span>}
                  {moment().format("MM/DD/YYYY")} -{param === null && moment().add(60, "days").format("MM/DD/YYYY")}
                  {param !== null && moment().add(parseInt(param), "days").format("MM/DD/YYYY")}
                </div>
              )}
            </div>
          )}

          {!loaderAction && items.length > 0 && (
            <div className="row justify-content-around">
              <div className="col-12">
                <DatatableTables columns={columns} data={items} desc={""} rowEvents={(e) => console.log("DataTableTables event click", e)}></DatatableTables>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
